/* ==========================================================================
   D'PANAS COFFEE — comportamiento de UI para las secciones propias
   Porta de web/assets/js/ui.js lo que necesitan las secciones dp-*:
   carruseles con scroll-snap y pestañas.

   Se inicializa solo y es idempotente: se puede volver a llamar sin duplicar
   listeners, algo necesario porque el editor de temas re-renderiza secciones
   sin recargar la página.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------- carruseles ---- */
  function initCarrusel(carousel) {
    if (carousel.__dpInit) return;
    carousel.__dpInit = true;

    var viewport = carousel.querySelector('.carousel__viewport');
    var prev = carousel.querySelector('.carousel__nav--prev');
    var next = carousel.querySelector('.carousel__nav--next');
    var dots = carousel.querySelector('.carousel__dots');
    if (!viewport) return;

    function ancho() { return viewport.clientWidth; }

    function paginas() {
      var w = ancho();
      return w ? Math.max(1, Math.ceil(viewport.scrollWidth / w)) : 0;
    }

    function construirDots() {
      if (!dots) return;
      var n = paginas();
      dots.innerHTML = '';
      if (n < 2) return;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.className = 'carousel__dot';
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir al grupo ' + (i + 1));
        b.dataset.page = i;
        dots.appendChild(b);
      }
    }

    function sincronizar() {
      var w = ancho();
      if (!w) return;
      var i = Math.round(viewport.scrollLeft / w);
      if (dots) {
        Array.prototype.forEach.call(dots.children, function (d, idx) {
          d.classList.toggle('is-active', idx === i);
        });
      }
      var max = viewport.scrollWidth - viewport.clientWidth - 2;
      if (prev) prev.disabled = viewport.scrollLeft <= 2;
      if (next) next.disabled = viewport.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { viewport.scrollBy({ left: -ancho(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { viewport.scrollBy({ left: ancho(), behavior: 'smooth' }); });
    if (dots) dots.addEventListener('click', function (e) {
      var d = e.target.closest('.carousel__dot');
      if (d) viewport.scrollTo({ left: ancho() * Number(d.dataset.page), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', function () {
      clearTimeout(viewport.__t);
      viewport.__t = setTimeout(sincronizar, 90);
    });

    carousel.__refrescar = function () { construirDots(); sincronizar(); };
    window.addEventListener('resize', function () {
      clearTimeout(carousel.__r);
      carousel.__r = setTimeout(carousel.__refrescar, 180);
    });

    carousel.__refrescar();
  }

  /* --------------------------------------------------------------- tabs ---- */
  function initTabs(grupo) {
    if (grupo.__dpInit) return;
    grupo.__dpInit = true;

    var tabs = grupo.querySelectorAll('[data-dp-tab]');
    var paneles = grupo.querySelectorAll('[data-dp-panel]');

    function activar(clave) {
      Array.prototype.forEach.call(tabs, function (t) {
        var on = t.dataset.dpTab === clave;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
      });
      Array.prototype.forEach.call(paneles, function (p) {
        p.classList.toggle('is-active', p.dataset.dpPanel === clave);
      });
      // los carruseles ocultos miden 0: hay que recalcularlos al mostrarse
      grupo.querySelectorAll('.tab-panel.is-active [data-dp-carousel]').forEach(function (c) {
        if (c.__refrescar) c.__refrescar();
      });
    }

    Array.prototype.forEach.call(tabs, function (t) {
      t.setAttribute('role', 'tab');
      t.addEventListener('click', function () { activar(t.dataset.dpTab); });
    });

    var inicial = grupo.querySelector('[data-dp-tab].is-active') || tabs[0];
    if (inicial) activar(inicial.dataset.dpTab);
  }

  function init(raiz) {
    var r = raiz || document;
    r.querySelectorAll('[data-dp-carousel]').forEach(initCarrusel);
    r.querySelectorAll('[data-dp-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // El editor de temas reemplaza secciones sin recargar
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.DPanas = { init: init };
})();
